var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "109.000000pt",
    height: "106.000000pt",
    viewBox: "0 0 109.000000 106.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,106.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338 1011 c-81 -26 -136 -61 -195 -123 -96 -102 -127 -195 -121 -367 3 -113 4 -118 46 -201 23 -47 42 -93 42 -102 0 -9 -12 -44 -26 -78 -22 -49 -25 -65 -16 -84 20 -44 129 -44 212 1 45 23 47 24 105 8 68 -17 220 -20 314 -4 194 31 344 190 372 394 20 145 -6 274 -77 380 -46 70 -101 115 -190 157 -69 33 -70 33 -239 35 -144 3 -179 0 -227 -16z m444 -78 c83 -39 154 -108 194 -188 28 -58 29 -65 29 -200 0 -136 -1 -142 -31 -205 -37 -78 -108 -151 -181 -185 -100 -48 -307 -57 -428 -19 l-51 16 -49 -31 c-35 -22 -61 -31 -92 -31 l-42 0 19 46 c30 69 26 108 -23 203 l-42 84 0 121 c1 148 20 207 96 291 102 111 174 136 384 132 145 -2 152 -3 217 -34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 562 c-18 -14 -21 -25 -16 -45 7 -31 48 -46 71 -27 22 18 19 67 -4 80 -25 13 -25 13 -51 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520 562 c-18 -14 -21 -25 -16 -45 7 -31 48 -46 71 -27 22 18 19 67 -4 80 -25 13 -25 13 -51 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 562 c-18 -14 -21 -25 -16 -45 7 -31 48 -46 71 -27 22 18 19 67 -4 80 -25 13 -25 13 -51 -8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contact-icon.90fabfc567c906cb22bfd021bf733682.svg";
export { ForwardRef as ReactComponent };